import React from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {EndlessList, mapListConfig} from 'components/ui-kit/EndlessList2.0';
import {childrenTotalCount$} from 'models/products/detail';
import {Gate, listState$} from 'models/products/detail/aggregate-content/list';
import {ProductContentAccessors, ProductContentFormattedRow, ProductContentRawRow} from 'types';

import {FlexRowElement, ListRow, RowElement, Text} from './styled';

interface Props {
    markingCode: string;
    gtin: string | null;
    configFunc: (t: TFunction) => Array<any>;
    dataMapper: (
        data: ProductContentRawRow[] | undefined,
        t: TFunction,
    ) => ProductContentFormattedRow[];
}

export const AggregateContentList = ({markingCode, gtin, configFunc, dataMapper}: Props) => {
    const {t} = useTranslation();
    const {data, pageIncremented} = useStore(listState$);
    const totalCount = useStore(childrenTotalCount$);
    const mappedData = React.useMemo(() => dataMapper(data, t), [dataMapper, data, t]);

    return (
        <>
            <Gate markingCode={markingCode} gtin={gtin} />
            <EndlessList<ProductContentFormattedRow>
                rows={mappedData}
                configurationBlock={mapListConfig(configFunc(t))}
                totalRowsCount={totalCount}
                hasMore={data.length < totalCount}
                renderRow={(row: ProductContentFormattedRow) => (
                    <ListRow>
                        <FlexRowElement>
                            <Text>{row[ProductContentAccessors.modifiedDate]}</Text>
                            <Text isGray>{row[ProductContentAccessors.status]}</Text>
                        </FlexRowElement>
                        <RowElement>
                            <Text>{row[ProductContentAccessors.code]}</Text>
                        </RowElement>
                        <RowElement>
                            <Text>{row[ProductContentAccessors.name]}</Text>
                        </RowElement>
                        <RowElement>
                            <Text isGray>
                                {row[ProductContentAccessors.packageType]}
                                {' • '}
                                {row[ProductContentAccessors.manufacturer]}
                            </Text>
                        </RowElement>
                    </ListRow>
                )}
                onNextPage={() => pageIncremented()}
            />
        </>
    );
};
